import 'dayjs/locale/ko';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const KST = 'Asia/Seoul';

export const formatCampaignDate = (value: string) =>
  dayjs(value).locale('ko').format('M/DD(ddd)');

export const formatCampaignDateTime = (value: string) =>
  dayjs(value).locale('ko').format('M/DD(ddd) HH:mm');

const SELECTION_ANNOUNCE_HOUR = 10;

export const formatSelectionAnnounceDateTime = (
  value: string,
  dateFormat: string,
) =>
  dayjs(value)
    .locale('ko')
    .hour(SELECTION_ANNOUNCE_HOUR)
    .format(`${dateFormat} A h시`);

export const formatCampaignMonthDay = (value: string) =>
  dayjs(value).format('M.D');

export const formatCampaignTime = (value: string) =>
  dayjs(value).format('HH:mm');

//* 서버(UTC)·해외 기기에서도 마감 당일이 같게 — 오프셋 없는 마감 시각은 한국 시각으로 읽는다
export const countDaysUntil = (
  endAt: string,
  now: dayjs.ConfigType = dayjs(),
) =>
  dayjs
    .tz(endAt, KST)
    .startOf('day')
    .diff(dayjs(now).tz(KST).startOf('day'), 'day');

export const countRemainingDays = (
  endAt: string,
  now: dayjs.ConfigType = dayjs(),
) => Math.max(countDaysUntil(endAt, now), 0);

export const formatRemainingDays = (
  endAt: string,
  now: dayjs.ConfigType = dayjs(),
) => {
  const remainingDays = countRemainingDays(endAt, now);

  return remainingDays > 0 ? `${remainingDays}일 남음` : '오늘 마감';
};
